/*
 * ping-sample-web-react-todo-oidc
 *
 * qriar-icon.js
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

import React from 'react';

const LOGO_URL = 'https://ais.qriardemo.digital/static/qriar-logo.png';

/**
 * @function QriarIcon - React component that displays the Qriar brand logo
 * @param {Object} props - React props object
 * @param {string} props.classes - A string of classnames to be set on component
 * @param {string} props.size - A string representing the intended height of the rendering
 * @returns {Object} - React JSX Object
 */
export default function QriarIcon({ classes = '', size = '24px' }) {
  return (
    <img
      className={classes}
      src={LOGO_URL}
      alt="Qriar"
      style={{ height: size, width: 'auto', display: 'inline-block' }}
    />
  );
}